import { render, staticRenderFns } from "./VideoPresenceTable.vue?vue&type=template&id=69811625&"
import script from "./VideoPresenceTable.vue?vue&type=script&lang=js&"
export * from "./VideoPresenceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports